"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schurDependencies = void 0;
var _dependenciesIdentityGenerated = require("./dependenciesIdentity.generated.js");
var _dependenciesMatrixGenerated = require("./dependenciesMatrix.generated.js");
var _dependenciesMultiplyGenerated = require("./dependenciesMultiply.generated.js");
var _dependenciesNormGenerated = require("./dependenciesNorm.generated.js");
var _dependenciesQrGenerated = require("./dependenciesQr.generated.js");
var _dependenciesSubtractGenerated = require("./dependenciesSubtract.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var schurDependencies = exports.schurDependencies = {
  identityDependencies: _dependenciesIdentityGenerated.identityDependencies,
  matrixDependencies: _dependenciesMatrixGenerated.matrixDependencies,
  multiplyDependencies: _dependenciesMultiplyGenerated.multiplyDependencies,
  normDependencies: _dependenciesNormGenerated.normDependencies,
  qrDependencies: _dependenciesQrGenerated.qrDependencies,
  subtractDependencies: _dependenciesSubtractGenerated.subtractDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createSchur: _factoriesAny.createSchur
};